/**
 * Stable device identifier.
 *
 * Generated once per device on first app launch and kept in localStorage.
 * Sent as the X-Device-Id header on every API request. The server uses
 * this to look up the active user + family for the device via KV.
 *
 * Not a security credential — purely an identity convenience for kids.
 */

const KEY = 'huroof:device-id';

export function getOrCreateDeviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Storage blocked (iOS private mode, etc.) — fall back to a per-tab id.
    return crypto.randomUUID();
  }
}
